export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyBzqPVSfx7_tgB29FnCIRbP68IadMOzEW0',
  authDomain: 'johno-todo.firebaseapp.com',
  databaseURL: 'https://johno-todo.firebaseio.com',
  projectId: 'johno-todo',
  storageBucket: 'johno-todo.appspot.com',
  messagingSenderId: '144200517190',
  appId: '1:144200517190:web:112f97a72928cd57316c47'
}
